import React from 'react';

const FollowUpExportacaoContext = React.createContext();

export default FollowUpExportacaoContext;
